export const PROFESSIONAL_DEVELOPMENT_PATH = '/professional-development';

/** Query param set when user arrives via a legacy URL redirect. */
export const PROFESSIONAL_DEVELOPMENT_FROM_PARAM = 'from';

export const LEGACY_CATALOG_REDIRECT_MESSAGES = {
  'white-papers':
    'The White Papers page has moved here. Explore interactive Professional Development packages below.',
  academy: 'The Academy has moved to Professional Development. Browse learning packages below.',
  'resource-library':
    'The Resource Library has moved to Professional Development. Browse learning packages below.',
};

export function professionalDevelopmentLessonPath(slug) {
  return `${PROFESSIONAL_DEVELOPMENT_PATH}/${slug}`;
}

export function professionalDevelopmentCatalogPath(from) {
  if (!from) return PROFESSIONAL_DEVELOPMENT_PATH;
  return `${PROFESSIONAL_DEVELOPMENT_PATH}?${PROFESSIONAL_DEVELOPMENT_FROM_PARAM}=${encodeURIComponent(from)}`;
}
